// extracted by mini-css-extract-plugin
export default {"btn2":"login_btn2__2VbTN","btn_b":"login_btn_b__JzKVa","btn_w":"login_btn_w__EoDZu"};